import React, { useEffect, useState } from 'react';
import { related_versions_ticket_path } from 'js-routes/generated/routes';
import { number } from 'prop-types';
import HistoryList from './HistoryList';

const TicketHistory = ({ ticketId = null }) => {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(true);

    void (async () => {
      try {
        const response = await fetch(related_versions_ticket_path(ticketId));
        const data = await response.json();
        setVersions(data.versions);
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
      } finally {
        setLoading(false);
      }
    })();
  }, [ticketId]);

  return <HistoryList versions={versions} loading={loading} />;
};

TicketHistory.propTypes = {
  ticketId: number,
};

export default TicketHistory;
